/* ------------------------------------------- */
/*   Save the main form in redux between steps as we change route
/* ------------------------------------------- */

import {
  doSectionSpecificActionsAndsaveFormData,
  reValidateSection,
} from 'AppSrc/core/data-structures/data-utility-functions';

import { setCreateCrqCoordinatorToLoggedInUser } from './actions-crq-coordinator';




const SAVE_FORM_DATA = 'SAVE_FORM_DATA';
const SET_RISK_VALUE = 'SET_RISK_VALUE';
const DELETE_ALL_DATA_FOR_FORM = 'DELETE_ALL_DATA_FOR_FORM';
const SAVE_FORM_SECTION_ERRORS = 'SAVE_FORM_SECTION_ERRORS';
const CLEAR_FORM_ERRORS = 'CLEAR_FORM_ERRORS';
const SUBMIT_FORM_REQUEST = 'SUBMIT_FORM_REQUEST';
const SUBMIT_FORM_SUCCESS = 'SUBMIT_FORM_SUCCESS';
const SUBMIT_FORM_ERROR = 'SUBMIT_FORM_ERROR';
const CLEAR_SUBMIT_FORM_ERROR = 'CLEAR_SUBMIT_FORM_ERROR';
const SWITCH_LOCAL_WIIS_FOR_SERVER_WIIS = 'SWITCH_LOCAL_WIIS_FOR_SERVER_WIIS';
const SWITCH_LOCAL_RELATIONSHIPS_FOR_SERVER_RELATIONSHIPS = 'SWITCH_LOCAL_RELATIONSHIPS_FOR_SERVER_RELATIONSHIPS';
const SET_SPONSOR_MAIN_FORM = 'SET_SPONSOR_MAIN_FORM';
const SET_UNSAVED_RELATIONSHIPS_MAIN_FORM = 'SET_UNSAVED_RELATIONSHIPS_MAIN_FORM';

/* ------ ACTION CREATORS ------ */

const saveFormDataAction = (params = {}) => {
  const {
    formId,
    sectionData,
  } = params;

  return ({
    type: SAVE_FORM_DATA,
    payload: {
      formId,
      sectionData,
    },
  });
};

const setRiskValue = (params = {}) => {
  const {
    formId,
    riskValue,
  } = params;
  return ({
    type: SET_RISK_VALUE,
    payload: {
      formId,
      riskValue,
    },
  });
};


const deleteAllDataForForm = (formId) => ({
  type: DELETE_ALL_DATA_FOR_FORM,
  payload: {
    formId,
  },
});

const saveFormSectionErrorsAction = (params = {}) => {
  const {
    formId,
    sectionId,
    errors,
  } = params;

  return ({
    type: SAVE_FORM_SECTION_ERRORS,
    payload: {
      formId,
      sectionId,
      errors,
    },
  });
};




const clearFormErrorsAction = (formId) => ({
  type: CLEAR_FORM_ERRORS,
  payload: {
    formId,
  },
});

const submitFormRequest = (formId) => ({
  type: SUBMIT_FORM_REQUEST,
  payload: {
    formId,
  },
});

const submitFormSuccess = (formId) => ({
  type: SUBMIT_FORM_SUCCESS,
  payload: {
    formId,
  },
});

const submitFormError = (formId, error) => ({
  type: SUBMIT_FORM_ERROR,
  payload: {
    formId,
    error,
  },
});

const clearSubmitFormError = (formId, error) => ({
  type: CLEAR_SUBMIT_FORM_ERROR,
  payload: {
    formId,
  },
});

const switchLocalWIIsForServerWIIs = (formId, wiis) => ({
  type: SWITCH_LOCAL_WIIS_FOR_SERVER_WIIS,
  payload: {
    formId,
    wiis,
  },
});

const switchLocalRelationshipsForServerRelationships = (formId, relationships) => ({
  type: SWITCH_LOCAL_RELATIONSHIPS_FOR_SERVER_RELATIONSHIPS,
  payload: {
    formId,
    relationships,
  },
});

const setSponsorMainForm = ({ formId, sponsor }) => ({
  type: SET_SPONSOR_MAIN_FORM,
  payload: {
    formId,
    sponsor,
  },
});

const setUnsavedRelationshipsMainForm = ({ formId, unsavedRelationships }) => ({
  type: SET_UNSAVED_RELATIONSHIPS_MAIN_FORM,
  payload: {
    formId,
    unsavedRelationships,
  },
});




const saveFormData = (params) => (dispatch, getState) => {

  const {
    formId,
    sectionData,
    editingStatus,
  } = params;

  const state = getState();
  const userRoles = state.auth.user.roles;

  const currentFormData = state.mainForm.formData[formId];
  const {
    sectionId,
  } = sectionData;


  // FN: 09/06/2020
  // The following actions are different based on if the user has saved that section yet. Note
  // that sometimes section data will exist (such as the work information items section) without
  // it being in formSectionsByDisplayOrder. This is because we have generated data for that section
  // but the user has not.
  const isNewSection = !currentFormData.formSectionsByDisplayOrder.includes(sectionId);

  const sharedActions = {
    saveSectionAction: saveFormDataAction,
    deleteAllDataForForm,
    setCreateCrqCoordinatorToLoggedInUser,
    setRiskValue,
    setSponsor: setSponsorMainForm,
    setUnsavedRelationships: setUnsavedRelationshipsMainForm,
  };

  if (isNewSection) {
    doSectionSpecificActionsAndsaveFormData({
      formId,
      sectionData,
      dispatch,
      currentFormData,
      editingStatus,
      userRoles,
      actions: {
        ...sharedActions,
      },
    });
    return null;
  }
  // If the user is editing a section, we check every section's data again in order to make sure there are no
  // side affects or errors. For example if sectionOne no longer has expedited selected, sectionTwo loses it's expedited
  // questions
  dispatch(clearFormErrorsAction(formId));

  currentFormData.formSectionsByDisplayOrder.forEach((sectionIdFromArray, index) => {
    // The section data to revalidate (and save) is either the new section data for the section we are editing
    // or the existing section data for the rest of the sections
    const sectionDataToRevalidate = sectionIdFromArray === sectionId ? sectionData : currentFormData.dataByFormSectionId[sectionIdFromArray];
    const newState = getState();
    const newFormData = newState.mainForm.formData[formId];

    // some sectionSpecificActions can cause whole sections of the form to no longer be necessary.
    const sectionIsStillInForm = newState.mainForm.formData[formId].formSectionsByDisplayOrder.includes(sectionIdFromArray);


    if (sectionIsStillInForm) {
      reValidateSection({
        formId,
        formData: newFormData,
        sectionData: sectionDataToRevalidate,
        dispatch,
        userRoles,
        editingStatus,
        actions: {
          ...sharedActions,
          saveFormSectionErrorsAction,
        },
      });
    }
    return null;
  });
  return null;
};




export {
  saveFormDataAction,
  setRiskValue,
  deleteAllDataForForm,
  saveFormSectionErrorsAction,
  clearFormErrorsAction,
  submitFormRequest,
  submitFormSuccess,
  submitFormError,
  saveFormData,
  clearSubmitFormError,
  switchLocalWIIsForServerWIIs,
  switchLocalRelationshipsForServerRelationships,
  setSponsorMainForm,
  setUnsavedRelationshipsMainForm,
  SAVE_FORM_DATA,
  SET_RISK_VALUE,
  DELETE_ALL_DATA_FOR_FORM,
  SAVE_FORM_SECTION_ERRORS,
  CLEAR_FORM_ERRORS,
  SUBMIT_FORM_REQUEST,
  SUBMIT_FORM_SUCCESS,
  SUBMIT_FORM_ERROR,
  CLEAR_SUBMIT_FORM_ERROR,
  SWITCH_LOCAL_WIIS_FOR_SERVER_WIIS,
  SWITCH_LOCAL_RELATIONSHIPS_FOR_SERVER_RELATIONSHIPS,
  SET_SPONSOR_MAIN_FORM,
  SET_UNSAVED_RELATIONSHIPS_MAIN_FORM,
};
